import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toast";
import { changeView, setIsCertified } from "../actions/assessment";
import config from "../config/config-secret.json";
import { SaveUserStateToServerHelper } from "./Helper";

import { Translate } from "react-redux-i18n";

export class JobApplicationForm2 extends Component {
  state = {
    highest_education_level_achieved: "",
    schoolFields: [
      {
        school_name: "",
        school_city: "",
        school_state: "",
        number_years_attended: "",
        field_of_study: "",
        degree_earned: "",
        did_graduate0: "",
      },
    ],
    vocationalTechnicalFields: {
      vocational_school_name: "",
      vocational_school_city: "",
      vocational_school_state: "",
      vocational_number_years_attended: "",
      vocational_field_of_study: "",
      vocational_degree_earned: "",
      vocational_did_graduate: "",
    },
    additional_educational_experience: "",
    is_application_certified: "",
    errors: {
      highest_education_level_achieved: "",
      schools: [
        {
          school_name: "",
          school_city: "",
          school_state: "",
        },
      ],
      is_application_certified: "",
    },
  };

  retrieveJobApplication = async () => {
    const tester_id = this.props.assessment.tester_id;
    await axios
      .get(
        config.API_DOMAIN +
          `/v2/job_application/details/?tester_id=${tester_id}`
      )
      .then((response) => {
        if (response.data.success === true) {
          const data = response.data;
          if (data.data.education) {
            this.setState({
              highest_education_level_achieved:
                data.data.job_application.highest_education_level_achieved,
              schoolFields: data.data.education.map((data, index) => {
                return {
                  school_name: data.school_name,
                  school_city: data.school_city,
                  school_state: data.school_state,
                  number_years_attended: data.number_years_attended,
                  field_of_study: data.field_of_study,
                  degree_earned: data.degree_earned,
                  [`did_graduate${index}`]: data.did_graduate_new
                    ? data.did_graduate_new.toString()
                    : "",
                  // "did_graduate": data.did_graduate.toString(),
                  // [`did_graduate${index}`]: data.did_graduate.toString(),
                };
              }),
              vocationalTechnicalFields: data.data.vocational_technical,
              additional_educational_experience:
                data.data.job_application.additional_educational_experience,
              is_application_certified:
                data.data.job_application.is_application_certified,
              errors: {
                highest_education_level_achieved: data.data.job_application
                  .highest_education_level_achieved
                  ? ""
                  : "This field is required.",
                schools: data.data.education.map((data) => {
                  return {
                    school_name: data.school_name
                      ? ""
                      : "This field is required.",
                    school_city: data.school_city
                      ? ""
                      : "This field is required.",
                    school_state: data.school_state
                      ? ""
                      : "This field is required.",
                  };
                }),
                is_application_certified: data.data.job_application
                  .is_application_certified
                  ? ""
                  : "Please respond to this statement.",
              },
            });
          }
        }
      });
  };

  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
    this.retrieveJobApplication();
  }

  changeHighestLevel = (event) => {
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "highest_education_level_achieved":
        errors.highest_education_level_achieved =
          value === "" ? "This field is required." : "";
        break;
      default:
        break;
    }
    this.setState({
      errors,
      highest_education_level_achieved: value,
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "is_application_certified":
        const cleanSchoolFields = this.state.schoolFields.filter(
          (school, index) => {
            if (index > 0 && Object.values(school).every((v) => v === "")) {
              return false;
            }
            return true;
          }
        );

        const highest_education_level_achieved =
          this.state.highest_education_level_achieved;
        const schools = cleanSchoolFields;
        errors.highest_education_level_achieved =
          highest_education_level_achieved === ""
            ? "This field is required."
            : "";
        schools.map((school, index) => {
          errors.schools[index].school_name =
            school.school_name === "" ? "This field is required." : "";
          errors.schools[index].school_city =
            school.school_city === "" ? "This field is required." : "";
          errors.schools[index].school_state =
            school.school_state === "" ? "This field is required." : "";
        });
        errors.is_application_certified =
          value === "" ? "Please respond to this statement." : "";
        this.setState({ errors });
        if (this.validateForm(this.state.errors)) {
          this.props.setIsCertified(true);
        } else {
          this.props.setIsCertified(false);
        }
        break;
      default:
        break;
    }

    this.setState({
      errors,
      [name]: value,
    });
  };

  handleVocationalInputChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      vocationalTechnicalFields: {
        ...this.state.vocationalTechnicalFields,
        [name]: value,
      },
    });
  };

  handleMultipleFieldChange = (event, index, state) => {
    // event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    state[index][name] = value;

    switch (name) {
      case "school_name":
        errors.schools[index].school_name =
          value === "" ? "This field is required." : "";
        break;
      case "school_city":
        errors.schools[index].school_city =
          value === "" ? "This field is required." : "";
        break;
      case "school_state":
        errors.schools[index].school_state =
          value === "" ? "This field is required." : "";
        break;
      default:
        break;
    }

    this.setState({
      errors,
      state,
    });
  };

  addMoreSchool = () => {
    let newSchoolFields = {
      school_name: "",
      school_city: "",
      school_state: "",
      number_years_attended: "",
      field_of_study: "",
      degree_earned: "",
      did_graduate: "",
    };
    let newSchoolErrorField = {
      school_name: "",
      school_city: "",
      school_state: "",
    };

    if (this.state.schoolFields.length <= 2) {
      this.setState({
        errors: {
          ...this.state.errors,
          schools: [...this.state.errors.schools, newSchoolErrorField],
        },
        schoolFields: [...this.state.schoolFields, newSchoolFields],
      });
    }
  };

  removeSchool = (index) => {
    let data = [...this.state.schoolFields];
    let errorSchools = [...this.state.errors.schools];
    errorSchools.splice(index, 1);
    data.splice(index, 1);
    this.setState({
      errors: { ...this.state.errors, schools: errorSchools },
      schoolFields: data,
    });
  };

  validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      (val) => {
        if (Array.isArray(val)) {
          val.map((item, index) => {
            (item.school_name.length > 0 ||
              item.school_city.length > 0 ||
              item.school_state.length > 0) &&
              (valid = false);
          });
        } else {
          val.length > 0 && (valid = false);
        }
      }
    );
    return valid;
  };

  submitJobApplicationForm2 = () => {
    toast.hideAll();
    const cleanSchoolFields = this.state.schoolFields.filter(
      (school, index) => {
        if (index > 0 && Object.values(school).every((v) => v === "")) {
          return false;
        }
        return true;
      }
    );

    const highest_education_level_achieved =
      this.state.highest_education_level_achieved;
    const schools = cleanSchoolFields;
    const vocational_technical = this.state.vocationalTechnicalFields;
    const additional_educational_experience =
      this.state.additional_educational_experience;
    const is_application_certified = this.state.is_application_certified;
    let errors = this.state.errors;

    errors.highest_education_level_achieved =
      highest_education_level_achieved === "" ? "This field is required." : "";
    errors.is_application_certified =
      is_application_certified === ""
        ? "Please respond to this statement."
        : "";
    schools.map((school, index) => {
      errors.schools[index].school_name =
        school.school_name === "" ? "This field is required." : "";
      errors.schools[index].school_city =
        school.school_city === "" ? "This field is required." : "";
      errors.schools[index].school_state =
        school.school_state === "" ? "This field is required." : "";
    });

    this.setState({
      errors,
    });

    const tester_id = this.props.assessment.tester_id;
    if (this.validateForm(this.state.errors)) {
      axios
        .post(config.API_DOMAIN + "/v2/job_application/submit/", {
          tester_id: tester_id,
          highest_education_level_achieved: highest_education_level_achieved,
          schools: schools,
          vocational_technical: vocational_technical,
          additional_educational_experience: additional_educational_experience,
          is_application_certified: is_application_certified,
        })
        .then((res) => {
          console.log(res.data);
          document.querySelector("#initloader").style.display = "none";
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          // alert("Something went wrong. Please contact administrator!");
        });
      this.props.start_assessment();
    } else {
      toast.error("Please complete all required fields.", {
        backgroundColor: "#ed143d",
        color: "#ffffff",
      });
      console.error("Invalid Form");
    }
  };

  render() {
    // const i18n = require("react-redux-i18n").I18n;
    const { errors } = this.state;

    return (
      <div className="main container-fluid h-100 mt-lg-0 mt-xs-5">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="row  justify-content-center ">
                <div className="col-md-12">
                  <div className="test-info ">
                    <h3 className="mt-4 mb-3 text-center">Application Form</h3>
                    <hr className="my-5" />

                    {/* Education */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold mb-4">
                            Education
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label
                              htmlFor="highest_education_level_achieved"
                              className="text-black-50"
                            >
                              Highest level of education achieved *
                            </label>
                            <select
                              className="form-control"
                              name="highest_education_level_achieved"
                              id="highehighest_education_level_achievedst_level"
                              onChange={this.changeHighestLevel}
                              value={
                                this.state.highest_education_level_achieved
                              }
                            >
                              <option value="" disabled hidden>
                                Select
                              </option>
                              <option value="high_school_ged">
                                High School or GED
                              </option>
                              <option value="associates">Associates</option>
                              <option value="bachelors">Bachelors</option>
                              <option value="masters">Masters</option>
                              <option value="doctorate">Doctorate</option>
                            </select>
                            {errors.highest_education_level_achieved.length >
                              0 && (
                              <span className="error">
                                {errors.highest_education_level_achieved}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      {this.state.schoolFields.map((input, index) => {
                        return (
                          <div
                            className={`row ${index > 0 ? "add-card" : ""}`}
                            key={index}
                          >
                            {index > 0 ? (
                              <div className="col-12">
                                <button
                                  type="button"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => this.removeSchool(index)}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                            ) : null}
                            <div className="col-12">
                              <label className="text-black-50 mb-0" htmlFor=" ">
                                {index > 0
                                  ? `College or University Name *`
                                  : `Name of School attended (If attended more than one, please list last attended). *`}
                              </label>
                              <div className="form">
                                <input
                                  type="text"
                                  name="school_name"
                                  id="school_name"
                                  className="form-control pl-0"
                                  value={input.school_name || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />

                                {errors.schools[index].school_name.length >
                                  0 && (
                                  <span className="error">
                                    {errors.schools[index].school_name}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="school_city"
                                  id="school_city"
                                  className="form-control"
                                  placeholder="School City"
                                  value={input.school_city || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />
                                <label htmlFor=" ">City *</label>
                                {errors.schools[index].school_city.length >
                                  0 && (
                                  <span className="error">
                                    {errors.schools[index].school_city}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="school_state"
                                  id="school_state"
                                  className="form-control"
                                  placeholder="School State"
                                  value={input.school_state || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                  required
                                />
                                <label htmlFor=" ">State *</label>
                                {errors.schools[index].school_state.length >
                                  0 && (
                                  <span className="error">
                                    {errors.schools[index].school_state}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="number_years_attended"
                                  id="number_years_attended"
                                  className="form-control"
                                  placeholder="No. of years attended"
                                  value={input.number_years_attended || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />
                                <label className="text-xs" htmlFor=" ">
                                  Number of years attended
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="field_of_study"
                                  id="field_of_study"
                                  className="form-control"
                                  placeholder="Field of Study"
                                  value={input.field_of_study || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />
                                <label htmlFor=" ">Field of Study</label>
                              </div>
                            </div>
                            {index > 0 ? (
                              <div className="col-12">
                                <div className="form-group">
                                  <label
                                    htmlFor="degree_earned"
                                    className="text-black-50"
                                  >
                                    Highest degree earned?
                                  </label>
                                  <select
                                    className="form-control"
                                    name="degree_earned"
                                    id="degree_earned"
                                    value={input.degree_earned || ""}
                                    onChange={(event) =>
                                      this.handleMultipleFieldChange(
                                        event,
                                        index,
                                        this.state.schoolFields
                                      )
                                    }
                                  >
                                    <option value="" disabled hidden>
                                      Select..
                                    </option>
                                    <option value="did_not_complete">
                                      Did Not Complete Degree
                                    </option>
                                    <option value="associates">
                                      Associates
                                    </option>
                                    <option value="bachelors">Bachelors</option>
                                    <option value="masters">Masters</option>
                                    <option value="doctorate">Doctorate</option>
                                  </select>
                                </div>
                              </div>
                            ) : null}
                            <div className="col-12 mb-4">
                              <label
                                htmlFor=" "
                                className="d-block text-black-50"
                              >
                                Did you graduate?
                              </label>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`did_graduate${index}`}
                                  id={`did_graduate${index}1`}
                                  checked={
                                    input["did_graduate" + index.toString()] ===
                                    "true"
                                  }
                                  value="true"
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`did_graduate${index}1`}
                                >
                                  YES
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`did_graduate${index}`}
                                  id={`did_graduate${index}2`}
                                  checked={
                                    input["did_graduate" + index.toString()] ===
                                    "false"
                                  }
                                  value="false"
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.schoolFields
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`did_graduate${index}2`}
                                >
                                  NO
                                </label>
                              </div>
                            </div>

                            {[
                              "associates",
                              "bachelors",
                              "masters",
                              "doctorate",
                            ].includes(
                              this.state.highest_education_level_achieved
                            ) && index === 0 ? (
                              <div className="col-lg-12">
                                <label htmlFor=" " className="text-black-50">
                                  If you attended one or more
                                  colleges/universities, please list them below.
                                </label>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                      {[
                        "associates",
                        "bachelors",
                        "masters",
                        "doctorate",
                      ].includes(this.state.highest_education_level_achieved) &&
                      this.state.schoolFields.length <= 2 ? (
                        <div className="row">
                          <div className="col-12 mb-3">
                            <button
                              className="btn btn-outline-secondary btn-xl d-block d-md-inline-block"
                              onClick={this.addMoreSchool}
                            >
                              + Add Another University
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </form>

                    <hr className="my-5" />

                    {/* Vocational or Technical school */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold">
                            Vocational or Technical school
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_school_name"
                              id="vocational_school_name"
                              className="form-control"
                              placeholder="School Name"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_school_name || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label htmlFor=" ">School Name</label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_school_city"
                              id="vocational_school_city"
                              className="form-control"
                              placeholder="City"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_school_city || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label htmlFor=" ">City</label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_school_state"
                              id="vocational_school_state"
                              className="form-control"
                              placeholder="State"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_school_state || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label htmlFor=" ">State</label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_number_years_attended"
                              id="vocational_number_years_attended"
                              className="form-control"
                              placeholder="Number of years attended"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_number_years_attended || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label className="text-xs" htmlFor=" ">
                              Number of years attended
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_field_of_study"
                              id="vocational_field_of_study"
                              className="form-control"
                              placeholder="Field of Study"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_field_of_study || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label htmlFor=" ">Field of Study</label>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <label htmlFor=" " className="d-block text-black-50">
                            Did you graduate?
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="vocational_did_graduate"
                              id="vocational_did_graduate1"
                              value="true"
                              checked={
                                this.state.vocationalTechnicalFields
                                  .vocational_did_graduate === "true"
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="vocational_did_graduate1"
                            >
                              YES
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="vocational_did_graduate"
                              id="vocational_did_graduate2"
                              value="false"
                              checked={
                                this.state.vocationalTechnicalFields
                                  .vocational_did_graduate === "false"
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="vocational_did_graduate2"
                            >
                              NO
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="vocational_degree_earned"
                              id="vocational_degree_earned"
                              className="form-control"
                              placeholder="Degree Earned"
                              value={
                                this.state.vocationalTechnicalFields
                                  .vocational_degree_earned || ""
                              }
                              onChange={this.handleVocationalInputChange}
                            />
                            <label className="text-xs" htmlFor=" ">
                              IF YES, What degree did you earn?
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                          <label htmlFor=" " className="text-black-50">
                            Please list any additional seminars, classes, or
                            other educational experience which may help qualify
                            you for this position.
                          </label>
                          <div className="form-label-group">
                            <textarea
                              className="form-control"
                              name="additional_educational_experience"
                              id="additional_educational_experience"
                              rows="3"
                              value={
                                this.state.additional_educational_experience ||
                                ""
                              }
                              onChange={this.handleInputChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </form>

                    <div className="my-5"></div>

                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12 mb-3">
                          <p className="text-left">
                            By choosing "Yes" below, you certify that your
                            answers are true and complete to the best of your
                            knowledge. You understand that failure to reveal any
                            prior employment, or giving false or misleading
                            information on any part of this application can
                            result in disqualification from employment
                            consideration or, if hired, may be grounds for
                            termination.
                          </p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label
                              htmlFor="certifyAnswer"
                              className="text-black-50 font-weight-bold"
                            >
                              I certify my answers on this application *
                            </label>
                            <select
                              className="form-control"
                              name="is_application_certified"
                              id="is_application_certified"
                              onChange={this.handleInputChange}
                              value={this.state.is_application_certified}
                            >
                              <option value="" disabled hidden>
                                Select
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            {errors.is_application_certified.length > 0 && (
                              <span className="error">
                                {errors.is_application_certified}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>

                    <div className="button-wrap my-5">
                      <button
                        onClick={this.submitJobApplicationForm2}
                        className="btn btn-main btn-global d-block d-lg-inline-block"
                      >
                        <Translate value="submit" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
});

const mapDispatchToProps = (dispatch) => ({
  start_assessment: () => dispatch(changeView("instruction")),
  setIsCertified: (is_certify) => dispatch(setIsCertified(is_certify)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobApplicationForm2);
